import React, { useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import classes from "../AssignTrainees/AssignTrainees.module.css";
import {
  getAllClassRequestIds,
  getClassRequest,
  getTrainees,
  getRosterTraineesByClassReqId,
  saveAssignRosters,
  getRosterDetails,
  getRosterConfigDetailsForAssignTrainee,
  getConfigurationValues,
} from "services/userServices";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import BackdropComponent from "../Spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { assignTraineeActions } from "../../Store/AssignTrainee";
import CustomList from "./CustomList";
import { useNavigate, useLocation } from "react-router-dom";
import SnackBar from "components/SnackBar/SnackBar";
import DialogBox from "components/ConfirmationDialog/DialogBox";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import { isEditable } from "./utils";
import TraineeSourceList from "./TraineeSourceList";
import { useTranslation } from "react-i18next";
import applicationUsageLog from "../../utils/applicationUsagesLog";
import { CustomButton } from "components/RosterConfig/RosterConfigStyle";
import { Paper, Tooltip, Typography } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ExpandMoreIcon
        sx={{ fontSize: "1.5rem", color: "#3F5765", fontWeight: "bold" }}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const concatenateDateTime = (date, time) => {
  if (!date || !time) return null;
  return (
    moment.utc(date).format("YYYY-MM-DD") +
    "T" +
    moment.utc(time, ["hh:mm:ss a"]).format("HH:mm")
  );
};

export default function AssignTrainees() {
  const [classReqDetails, setClassReqDetails] = React.useState([]);
  const [classReqIds, setClassReqIds] = React.useState([]);
  const [selectedclassReqId, setSelectedclassReqId] = useState("");
  const [selectedClassRoster, setSelectedClassRoster] = useState("");
  const combinedRef = useRef("");
  const [classRosters, setClassRosters] = useState([]);
  const [showCreateIdmTicket, setShowCreateIdmTicket] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rosterConfigDetails, setRosterConfigDetails] = useState([
    {
      rosterId: null,
      productTrainingDateTime: null,
      productionStartDate: null,
      tciDateTime: null,
      techTestDateTime: null,
      ttfDateTime: null,
      techEquipmentSolutionId: null,
    },
  ]);
  const [selectedRoster, setSelectedRoster] = useState("");

  const getRosterId = () => {
    if (selectedRoster === "") {
      return defaultRoster;
    } else if (selectedRoster == 0) {
      return "";
    } else {
      return selectedRoster;
    }
  };

  const [generateIdmTicketNew, setGenerateIdmTicketNew] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const [showClassRequestDrawer, setShowClassRequestDrawer] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const { t } = useTranslation(["AssignTrainees"]);
  const [expanded, setExpanded] = React.useState("panel1");
  const [showDiscardDialog, setShowDiscardDialog] = useState(false);

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const assignTraineeData = useSelector((state) => state.assignTrainees);
  const traineesData = assignTraineeData.traineesData;
  const rosterList =
    assignTraineeData?.rosterList.length > 0
      ? assignTraineeData.rosterList.filter((item) => item?.rosterStatus !== 2) //ASTT-2485 removing cancelled rosters from the list
      : [];
  const checked = assignTraineeData?.checked; //All checked Items.
  const [rosterCount, setRosterCount] = useState(0);
  const requisitionID = assignTraineeData?.requisitionID;
  const defaultRoster = assignTraineeData?.IDMRosters[0];
  const defaultClassRequestId = assignTraineeData?.classRequestId;

  const dispatch = useDispatch();

  useEffect(() => {
    let cancelled = false;

    const fetchConfigValue = async () => {
      try {
        const response = await getConfigurationValues(
          "appsettings:generateIdmTicketNew",
        );

        if (cancelled) return;

        if (response?.statusCode === 200) {
          if (!cancelled) {
            setGenerateIdmTicketNew(
              response?.data?.generateIdmTicketNew.toString() === "1",
            );
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch config value:", error);
        }
      }
    };

    fetchConfigValue();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      if (!cancelled) {
        setLoading(true);
      }

      try {
        if (assignTraineeData?.rosterList.length) {
          dispatch(assignTraineeActions.resetAssignTrainee());
        }

        const userDetails = await getAllClassRequestIds();

        if (cancelled) return;

        const classRequestIds = userDetails.data.map((item) =>
          item.classRequestId.toString(),
        );

        if (!cancelled) {
          setClassReqIds(classRequestIds);
          dispatch(assignTraineeActions.setAllClassRequestIds(classRequestIds));
        }

        await getRosterTrainees(location?.state?.classRequestId);

        if (cancelled) return;

        if (!cancelled) {
          // Set searched parameters from location state
          if (location?.state?.classRequestId) {
            dispatch(
              assignTraineeActions.setSearchedClassReqId(
                location?.state?.classRequestId,
              ),
            );
          }

          if (location?.state?.classRosterId) {
            dispatch(
              assignTraineeActions.setSearchedRoster(
                location?.state?.classRosterId,
              ),
            );
          }

          // Log application usage
          applicationUsageLog(
            localStorage.getItem("User"),
            localStorage.getItem("EmailId"),
            "ASTT",
            "Assign Trainee",
          );

          setLoading(false);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to initialize assign trainee:", error);
          setLoading(false);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleChange = (event, value) => {
    if (value) {
      getRosterTrainees(value);
    }
  };

  const prepareRosterConfigDetails = (data) => {
    return data?.map((item) => {
      return {
        ...rosterConfigDetails,
        rosterId: item?.ClassRosterId,
        productTrainingDateTime: item?.ProductTrainingDate
          ? concatenateDateTime(
              item.ProductTrainingDate,
              item?.ProductTrainingTime,
            )
          : null,
        productionStartDate: item?.ProductionDate
          ? moment.utc(item.ProductionDate).format("YYYY-MM-DD")
          : null,
        tciDateTime: item?.TCIDate
          ? concatenateDateTime(item.TCIDate, item?.TCITime)
          : null,
        techTestDateTime: item?.TechTestDate
          ? concatenateDateTime(item.TechTestDate, item?.TechTestTime)
          : null,
        ttfDateTime: item?.TTFDate
          ? concatenateDateTime(item.TTFDate, item.TTFTime)
          : null,
        techEquipmentSolutionId: item?.TechEquipmentSolutionId ?? null,
      };
    });
  };

  const checkIfRosterCanCreateIdmTicket = (rosterId) => {
    const rosterDetails = rosterConfigDetails?.find(
      (item) => item?.rosterId === rosterId,
    );
    if (rosterDetails) {
      return (
        rosterDetails.productTrainingDateTime &&
        rosterDetails.productionStartDate &&
        ((rosterDetails.techEquipmentSolutionId !== 14 &&
          (rosterDetails.tciDateTime || rosterDetails.techTestDateTime)) ||
          (rosterDetails.techEquipmentSolutionId === 14 &&
            rosterDetails.ttfDateTime))
      );
    }
    return false;
  };

  const getRosterTrainees = async (value) => {
    setLoading(true);
    setSelectedclassReqId(value);
    if (value) {
      dispatch(assignTraineeActions.resetAssignTrainee());
      dispatch(assignTraineeActions.setClassRequestId(value));

      const response = await getClassRequest(value);
      const userDetails = await getRosterTraineesByClassReqId(value);
      const rosterDetails = await getRosterDetails(0, value);
      const rosterConfigDetailsResponse =
        await getRosterConfigDetailsForAssignTrainee(value);
      if (userDetails?.message === "Success") {
        let rosterTraineesData = getRosterTraineesData(
          userDetails?.data,
          rosterDetails?.data,
        );
        let totalTraineeCount = userDetails.data.filter(
          (value) => value?.OracleId !== null,
        )?.length;

        //setLeft(oracleIds);  //Setting Source
        dispatch(assignTraineeActions.setTotalTraineeCount(totalTraineeCount));
        dispatch(assignTraineeActions.AddExistingRosters(rosterTraineesData)); //Setting Source List
        dispatch(assignTraineeActions.setInitialRosterList(rosterTraineesData));
        dispatch(assignTraineeActions.setTraineesData(userDetails?.data));
        setRosterCount(rosterDetails?.data?.classRosters.length);
      }
      if (rosterConfigDetailsResponse?.message === "Success") {
        const details = prepareRosterConfigDetails(
          rosterConfigDetailsResponse?.data,
        );
        setRosterConfigDetails(details);
        dispatch(assignTraineeActions.setRosterConfigDetails(details));
      }
      setClassReqDetails(response?.data?.classRequestDetail);
    } else {
      handleReset();
    }

    setLoading(false);
  };
  const getRosterTraineesData = (data, rosterDetails) => {
    const rosters = [...new Set(data.map((value) => value?.ClassRosterId))]; //Getting distinct Roster ids

    setClassRosters(rosters);

    const rostersWithNoTrainees = [
      ...new Set(
        data.map((value) => {
          if (value?.OracleId === null) return value?.ClassRosterId;
        }),
      ),
    ];

    const checkIfRosterIsLocked = (rosterId) => {
      const rosterDetail = rosterDetails?.classRosters?.find(
        (item) => item?.classRosterId === rosterId,
      );

      if (rosterDetail) {
        const rosterLockTimeStamp = rosterDetail?.assignTraineesLockTimestamp;
        return (
          rosterLockTimeStamp !== null && rosterLockTimeStamp !== undefined
        );
      }
      return false;
    };

    const rosterTrainees = rosters.map((rosterId) => {
      const isRosterEmpty = rostersWithNoTrainees.includes(rosterId);
      const rosterStatus = rosterDetails;
      return {
        rosterId: rosterId,
        Ids: isRosterEmpty
          ? []
          : data
              .filter((item) => item?.ClassRosterId === rosterId)
              .map((value) => `${value?.OracleId}-${value?.ClassRosterId}`),
        isEmptyRoster: isRosterEmpty,
        rosterStatus: rosterStatus?.classRosters.filter(
          (item) => item?.classRosterId === rosterId,
        )?.[0].rosterStatusId,
        isRosterLocked: checkIfRosterIsLocked(rosterId),
        canRosterCreateIdmTicket: checkIfRosterCanCreateIdmTicket(rosterId),
      };
    });

    return rosterTrainees;
  };

  const handleGetTrainees = async () => {
    if (!selectedclassReqId) {
      setSnack({
        open: true,
        message: "Please select a Class request Id",
        severity: "warning",
      });
      return;
    }

    const raw = combinedRef.current?.value?.trim() || "";
    if (!raw) {
      setSnack({
        open: true,
        message: "Please enter a requisition Id or Oracle Id",
        severity: "warning",
      });
      return;
    }
    let requistionId = null;
    let oracleIds = [];

    if (raw.includes(",")) {
      oracleIds = raw
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    } else if (/^\d+$/.test(raw) && raw.length === 7) {
      oracleIds = [raw];
    } else {
      requistionId = raw;
    }

    try {
      setLoading(true);
      const roasterId = 0;
      const res = await getTrainees(
        requistionId,
        oracleIds.join(","),
        roasterId,
        selectedclassReqId,
      );

      const data = res?.data ?? res;
      if (!data || data.length === 0) {
        setSnack({
          open: true,
          message: "No trainees returned",
          severity: "error",
        });
        dispatch(assignTraineeActions.setSourceList([]));
        dispatch(assignTraineeActions.setTraineesData([]));
        dispatch(assignTraineeActions.setUnAssignedTraineesList([]));
        return;
      }

      const Ids = data.map((v) => v?.OracleId).filter(Boolean);
      dispatch(assignTraineeActions.setSourceList(Ids));
      dispatch(assignTraineeActions.setTraineesData(data));
      dispatch(assignTraineeActions.setUnAssignedTraineesList(data));
      setExpanded(false);
    } catch (error) {
      console.error("Error fetching trainees:", error);
      setSnack({
        open: true,
        message: "Something went wrong while fetching",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setLoading(true);
    dispatch(assignTraineeActions.resetAssignTrainee());
    combinedRef.current.value = "";

    window.history.replaceState({}, document.title);
    setLoading(false);
  };

  const anyRostersModified = (rosterList) => {
    const allIDsList = rosterList.map((item) => item.Ids);
    let allIds = allIDsList.flat(99);
    let returnValue = false;

    for (const element of allIds) {
      if (isEditable(element, requisitionID) === true) {
        returnValue = true;
        break;
      }
    }

    return returnValue;
  };

  const handleSave = async () => {
    let rostersChanged = anyRostersModified(rosterList);

    if (rostersChanged === false) {
      setSnack({
        open: true,
        message: "Please assign any trainee to rosters to save.",
        severity: "warning",
      });
    } else {
      setLoading(true);

      const classRostersDetails = prepareSavePayload();
      const payload = {
        classRosters: classRostersDetails,
      };

      let response = await saveAssignRosters(payload);

      if (response?.message === "Success") {
        setSnack({
          open: true,
          message: "Saved successfully.",
          severity: "success",
        });
        combinedRef.current.value = "";
        getRosterTrainees(selectedclassReqId);
      } else {
        setSnack({
          open: true,
          message: "Save failed.",
          severity: "error",
        });
      }

      setLoading(false);
    }
  };

  const prepareSavePayload = () => {
    return rosterList.map((item) => {
      return {
        classRosterId: item?.rosterId,
        requisitionId: combinedRef.current.value,
        modifiedby: localStorage.getItem("User"),
        trainees: item.Ids.map((traineeId) => {
          return fetchTraineeDetails(traineeId);
        }),
      };
    });
  };

  const fetchTraineeDetails = (traineeId) => {
    const oracleId = traineeId.split("-").shift();

    const traineeDetails = traineesData.filter(
      (trainee) => trainee?.OracleId === oracleId,
    );

    return {
      candidateId: traineeDetails[0]?.CandidateId,
      employeeStatus: traineeDetails[0]?.EmployeeStatus,
      firstName: traineeDetails[0]?.FirstName,
      lastName: traineeDetails[0]?.LastName,
      oracleId: traineeDetails[0]?.OracleId,
      traineeStatus: traineeDetails[0]?.TraineeStatus,
    };
  };

  const handleChangePanel = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleCreateIDMTicket = () => {
    if (hasUnsavedChanges()) {
      showUnsavedChangesWarning();
      return;
    }

    if (!hasSelectedRosters()) {
      showNoRostersSelectedWarning();
      return;
    }

    const activeRoster = getActiveRoster();

    if (generateIdmTicketNew) {
      navigateToGenerateIdmTicket(activeRoster);
    } else {
      setShowCreateIdmTicket(true);
    }
  };

  // Helper functions
  const hasUnsavedChanges = () => {
    return assignTraineeData?.modifiedRosters.length > 0;
  };

  const handleBack = () => {
    if (anyRostersModified(rosterList)) {
      setShowDiscardDialog(true);
    } else {
      navigate(-1);
    }
  };

  const confirmDiscard = () => {
    setShowDiscardDialog(false);
    navigate(-1);
  };

  const hasSelectedRosters = () => {
    return assignTraineeData?.IDMRosters.length > 0;
  };

  const getActiveRoster = () => {
    return (
      rosterConfigDetails.find((r) => r.rosterId === getRosterId()) ||
      rosterConfigDetails[0] ||
      {}
    );
  };

  const showUnsavedChangesWarning = () => {
    setSnack({
      open: true,
      message:
        "Unsaved changes, please save or reset the modified roster lists.",
      severity: "warning",
    });
  };

  const showNoRostersSelectedWarning = () => {
    setSnack({
      open: true,
      message: "Please select rosters to include in IDM ticket creation",
      severity: "warning",
    });
  };

  const buildTtfTrainerData = (roster) => {
    const isTechEquipment14 = roster?.techEquipmentSolutionId === 14;

    return [
      isTechEquipment14 && roster?.ttfDateTime ? roster.ttfDateTime : null,
      !isTechEquipment14 && roster?.tciDateTime ? roster.tciDateTime : null,
      !isTechEquipment14 && roster.techTestDateTime
        ? roster.techTestDateTime
        : null,
      roster?.productionStartDate || null,
      roster?.productTrainingDateTime || null,
      roster?.trainerOracleId || null,
      roster?.trainerName || "",
      roster?.trainerEmail || "",
      isTechEquipment14,
    ];
  };

  const navigateToGenerateIdmTicket = (activeRoster) => {
    navigate("/home/generateidmticket", {
      state: {
        classRosterId: getRosterId(),
        classRequestId:
          selectedclassReqId === ""
            ? defaultClassRequestId
            : selectedclassReqId,
        askNowTDT: activeRoster.askNowTDT,
        ttfTrainerData: buildTtfTrainerData(activeRoster),
      },
    });
  };
  const getTechEquipsolutionId = (rosterId) => {
    const rosterDetail = rosterConfigDetails?.find(
      (item) => item?.rosterId === rosterId,
    );
    return rosterDetail?.techEquipmentSolutionId ?? 0;
  };

  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <Paper
        sx={{
          flexDirection: "column",
          boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.35)",
          padding: 2,
          overflow: "auto",
          height: "calc(100vh - 80px)",
          margin: 1,
        }}
      >
        <Grid container>
          <Grid item xs={2} sx={{ pb: 1 }}></Grid>
          {expanded === "panel1" ? (
            <Grid item xs={10} />
          ) : (
            <Grid
              item
              xs={10}
              sx={{
                pb: 1,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <CustomButton
                variant="outlined"
                sx={{
                  color: "#3299FF",
                }}
                onClick={handleBack}
              >
                {t("Back")}
              </CustomButton>
              {rosterCount > 0 && (
                <CustomButton
                  variant="contained"
                  sx={{
                    backgroundColor: "#3299FF",
                  }}
                  onClick={handleSave}
                >
                  {t("Save Roster List")}
                </CustomButton>
              )}
              {rosterCount > 0 && (
                <CustomButton
                  variant="contained"
                  sx={{
                    backgroundColor: "#3299FF",
                  }}
                  onClick={handleCreateIDMTicket}
                  endIcon={<ArrowOutwardIcon />}
                >
                  {t("Create IDM ticket")}
                </CustomButton>
              )}
            </Grid>
          )}
          <Grid item xs={12}>
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChangePanel("panel1")}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    fontFamily: "Urbanist, sans-serif",
                    color: "#3F5765",
                  }}
                >
                  {t("Assign Trainees")}{" "}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    sx={{
                      marginLeft: "5px",
                      marginTop: "10px",
                    }}
                  >
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          fontFamily: "Urbanist, sans-serif",
                          color: "#3F5765",
                        }}
                      >
                        {t("Class Request")}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          fontFamily: "Urbanist, sans-serif",
                          color: "#3F5765",
                        }}
                      >
                        {t("Program Name")}
                      </Typography>
                    </Grid>
                    <Grid item xs={2.5}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          fontFamily: "Urbanist, sans-serif",
                          color: "#3F5765",
                        }}
                      >
                        {t("Search by ID (Requisition ID or Oracle ID)")}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    sx={{
                      marginLeft: "5px",
                    }}
                  >
                    <Grid item xs={2}>
                      <Autocomplete
                        disablePortal
                        options={classReqIds}
                        getOptionLabel={(item) => item.toString()}
                        value={
                          selectedclassReqId !== "null"
                            ? selectedclassReqId
                            : ""
                        }
                        onChange={(event, value) => handleChange(event, value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              sx: {
                                color: "#3f5765",
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Tooltip title={classReqDetails?.program}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          disabled
                          value={classReqDetails?.program}
                          InputProps={{
                            sx: {
                              color: "#3f5765",
                            },
                          }}
                        ></TextField>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={2.5}>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder={t(
                          "Requisition ID or Oracle ID seperation with comma",
                        )}
                        variant="outlined"
                        inputRef={combinedRef}
                        InputProps={{
                          sx: {
                            color: "#3f5765",
                          },
                        }}
                      ></TextField>
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      alignItems="center"
                      sx={{
                        marginLeft: "10px",
                      }}
                    >
                      <CustomButton
                        variant="contained"
                        sx={{
                          backgroundColor: "#3299FF",
                        }}
                        onClick={handleGetTrainees}
                      >
                        {t("Get Trainees")}
                      </CustomButton>
                      {rosterCount > 0 && (
                        <CustomButton
                          sx={{
                            marginLeft: "10px",
                            backgroundColor: "#3299FF",
                          }}
                          variant="contained"
                          onClick={handleSave}
                        >
                          {t("Save Roster List")}
                        </CustomButton>
                      )}
                      {rosterCount > 0 && (
                        <CustomButton
                          variant="contained"
                          sx={{
                            marginLeft: "10px",
                            backgroundColor: "#3299FF",
                          }}
                          onClick={handleCreateIDMTicket}
                          endIcon={<ArrowOutwardIcon />}
                        >
                          {t("Create IDM ticket")}
                        </CustomButton>
                      )}
                      <CustomButton
                        variant="outlined"
                        sx={{
                          marginLeft: "10px",
                          color: "#3299FF",
                        }}
                        onClick={handleReset}
                      >
                        {t("Reset")}
                      </CustomButton>
                      <CustomButton
                        variant="outlined"
                        sx={{
                          marginLeft: "10px",
                          color: "#3299FF",
                        }}
                        onClick={handleBack}
                      >
                        {t("Back")}
                      </CustomButton>
                    </Grid>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12} sx={{ paddingTop: 1 }}>
            <Paper>
              <Grid container>
                <Grid item xs={5}>
                  {rosterCount > 0 && (
                    <TraineeSourceList
                      refreshTraineeList={() =>
                        getRosterTrainees(selectedclassReqId)
                      }
                    />
                  )}
                </Grid>
                <Grid item xs={6}>
                  {rosterCount > 0 ? (
                    <Grid container wrap="nowrap">
                      {rosterList.map((item) => {
                        return (
                          <Grid
                            item
                            xs={5}
                            sx={{ paddingLeft: 2 }}
                            key={item.rosterId}
                          >
                            <CustomList
                              key={item.rosterId}
                              items={item.Ids}
                              rosterId={item.rosterId}
                              isEmptyRoster={item.isEmptyRoster}
                              isRosterLocked={item.isRosterLocked}
                              canRosterCreateIdmTicket={checkIfRosterCanCreateIdmTicket(
                                item.rosterId,
                              )}
                              techEquipmentSolutionId={getTechEquipsolutionId(
                                item.rosterId,
                              )}
                            ></CustomList>
                          </Grid>
                        );
                      })}
                    </Grid>
                  ) : (
                    <div className={classes.NoRoster}>
                      <b>{t("No rosters available")}</b>{" "}
                    </div>
                  )}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
      <DialogBox
        isOpen={showDiscardDialog}
        isConfirmation={true}
        messageType="Confirmation"
        title={t("Discard changes?")}
        message={t("discardUnsavedMsg")}
        action={confirmDiscard}
        cancelAction={() => setShowDiscardDialog(false)}
      />
    </>
  );
}
